import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import ShowcaseGrid from '../components/Home/ShowcaseGrid';
import PublicationsSection from '../components/Home/PublicationsSection';
import NewsSection from '../components/Home/NewsSection';
import EventsSection from '../components/Home/EventsSection';
import MezunYorumlari from '../components/Home/MezunYorumlari';
const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ShowcaseGrid />
      <PublicationsSection />
      <NewsSection />
      <EventsSection />
      <MezunYorumlari />
    </div>
  );
};

export default Home; 